import { render, staticRenderFns } from "./DeleteAsset.vue?vue&type=template&id=a4569bcc&scoped=true"
import script from "./DeleteAsset.vue?vue&type=script&lang=js"
export * from "./DeleteAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4569bcc",
  null
  
)

export default component.exports